import { useEffect, useState } from 'react';

/**
 * Returns a debounced copy of `value` that updates only after `delay` ms of
 * inactivity. Useful for search inputs and filter forms.
 */
export function useDebounce<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
